module.exports = __webpack_public_path__ + "static/sport/bgi-pc.b2cc059.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/bgi-pc.png
// module id = Wcko
// module chunks = 0